import styled from 'styled-components';

export const AddressFormContainer = styled.form`
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 1.5rem;
    width: 100%;
    padding-top: 1.5rem;

    .foreigner-div {
        display: flex;
        align-items: center;
        justify-content: start;
        gap: 1rem;

        p {
            color: var(--Neutral-800, #27272A);
            font-family: 'Inter', sans-serif;
            font-size: 1rem;
            font-style: normal;
            font-weight: 500;
            line-height: 1.5rem;
            margin: 0;
            padding: 0;
        }
    }

    .input-dropdown button {
        padding: 0.75rem 1rem;
        line-height: 1.5rem;
        border-radius: 10px;
        width: 5rem;
    }
`;

export const Row = styled.div`
    display: flex;
    align-items: start;
    justify-content: space-evenly;
    width: 100%;
    gap: 0.75rem;
    overflow: visible;

    .input-item {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        gap: 0.5rem;
        /* width: 160px; */

        input {
            width: 100%;
        }
    }

    .input-allWidth {
        width: 100%;
    }

    label {
        color: var(--Neutral-900, #18181b);
        font-family: 'Inter', sans-serif;
        font-size: 1rem;
        font-style: normal;
        font-weight: 600;
        line-height: 1.3rem; /* 130% */
    }

    .dropdown-container  {
        /* background-color: red; */
        
        button {
            padding: .875rem 1rem;
            border-radius: .75rem;
            color: var(--Neutral-900, #18181B);
            font-family: 'Inter', sans-serif;
            font-size: 1rem;
            font-style: normal;
            font-weight: 400;
            line-height: 1.4rem;
        }
    }

    .dropdown-container.invalid label + button{
        border: 2px solid var(--Red-400, #e11d48);
        color: red;
    }

    .error-span {
        color: var(--Red-400, #e11d48);
        font-size: 0.75rem;
        font-weight: 500;
        line-height: 1rem;
    }
`;

export const SpanRequired = styled.span`
    color: var(--Red-400, #e11d48);
`;
